var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.template.name
      ? _c("div", { staticClass: "questionnaireGroupHeader" }, [
          _c("span", { staticClass: "questionnaireGroupHeaderText" }, [
            _vm._v(_vm._s(_vm.template.name)),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "questionnaireGroupCells" },
      _vm._l(_vm.model.cells, function (question) {
        return _c("questionnaire-form-question", {
          key: question.id,
          attrs: {
            globals: _vm.globals,
            model: question,
            template: _vm.getTemplate(question.id),
            response: _vm.response,
          },
          on: { change: _vm.$rbEmit },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }